import React from 'react';
import { Flex, Absolute } from 'rebass';
import styled from 'styled-components';
import { colors, shadows } from '../../tailwind';
import { Text } from '../common';
import { observer } from 'mobx-react';

@observer
export default class AddListingTimeline extends React.Component {
  render() {
    const {
      store,
      store: { status },
      stepChanged,
    } = this.props;

    return (
      <TimelineGrid>
        {status.steps.map((step, i) => {
          return [
            <div style={{ display: 'flex', alignItems: 'center' }} key={i}>
              <StepLine style={{ flex: 1 }} visible={i !== 0} />
              <StepCircle
                isValid={!step.hasErrors}
                isActive={step.current}
                onClick={step.canVisit ? () => stepChanged(step.name) : null}
                clickable={step.canVisit}
              >
                {(step.visited || store.editing) && !step.hasErrors ? (
                  <i className="fas fa-check-circle t-lxx" />
                ) : (step.visited || store.editing) && step.hasErrors ? (
                  <i
                    className="fas fa-times-circle t-lxx"
                    title={step.errors}
                  />
                ) : null}
              </StepCircle>
              <StepLine
                style={{ flex: 1 }}
                visible={i < status.steps.length - 1}
              />
            </div>,
            i < status.steps.length - 1 ? <StepLine visible /> : null,
          ];
        })}
        {status.steps.map((step, i) => {
          return [
            <div>
              <Text
                noclip
                primaryDark
                large
                clickable={step.canVisit}
                onClick={step.canVisit ? () => stepChanged(step.name) : null}
              >
                {step.label}
              </Text>
            </div>,
            <div />,
          ];
        })}
      </TimelineGrid>
    );
  }
}

const TimelineGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto 1fr auto 1fr auto 1fr auto 1fr auto 1fr auto;
  width: 100%;
  padding-left: 64px;
  padding-right: 64px;
  align-items: center;
`;

const StepCircle = styled.div`
  background-color: ${colors.background};
  border: ${p =>
    (!p.clickable ? '1px' : '0px') +
    ' solid ' +
    (p.clickable && !p.isValid
      ? colors.secondary
      : p.clickable
      ? colors.validated
      : colors.primaryDark)}
  border-radius: 50px;
  content: ' ';
  height: ${p => (p.isActive ? '22px' : '20px')};
  width: ${p => (p.isActive ? '22px' : '20px')};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  margin:-1px;
  color: ${p =>
    p.clickable && !p.isValid ? colors.secondary : colors.primaryDark};
  box-shadow: ${p => (p.isActive ? shadows.lgblue : null)};
  cursor: ${p => (p.clickable ? 'pointer' : null)};
`;

const StepLine = styled.div`
  border: ${p => `1px solid ${p.visible ? colors.primaryDark : 'transparent'}`}
  height: 2px;
  display: inline-block;
`;



// WEBPACK FOOTER //
// ./src/components_new/listing/AddListingTimeline.js